import type { enGudang } from '../en/gudang';

export const idGudang: Record<keyof typeof enGudang, string> = {
  'gudang.nav.overview': 'Ringkasan',
  'gudang.overview.title': 'Gudang',
  'gudang.overview.subtitle': 'Gudang di {branch}',
  'gudang.overview.warehouses': 'Gudang',
  'gudang.overview.warehousesDesc':
    'Setiap lokasi stok yang aktif adalah gudang. Zona dan rak diatur per gudang.',
  'gudang.overview.empty': 'Belum ada lokasi stok yang aktif.',
  'gudang.overview.addLocation': 'Tambah lokasi',
  'gudang.overview.default': 'Utama',
  'gudang.overview.binsPending': 'Belum ada zona atau rak — stok dicatat per lokasi.',
  'gudang.overview.binsOnShort': 'Rak aktif — stok dicatat per rak.',
  'gudang.overview.open': 'Buka {name}',
  'gudang.layout.title': 'Tata letak gudang',
  'gudang.layout.subtitle': 'Zona dan rak {code}',
  'gudang.layout.enabled': 'Rak aktif. Stok saat ini ada di STAGING.',
  'gudang.layout.off': 'Rak belum aktif',
  'gudang.layout.offDesc':
    'Stok dicatat per lokasi. Atur zona dan rak, lalu aktifkan rak: stok saat ini masuk ke rak STAGING sampai disimpan ke raknya.',
  'gudang.layout.enable': 'Aktifkan rak',
  'gudang.layout.enableTitle': 'Aktifkan rak untuk {name}?',
  'gudang.layout.enableBody':
    'Semua stok di lokasi ini ditempatkan di rak STAGING. Sejak itu setiap mutasi stok di sini juga memindahkan jumlah per rak.',
  'gudang.layout.enableWarning': 'Tidak dapat dinonaktifkan lagi.',
  'gudang.zone.add': 'Tambah zona',
  'gudang.zone.title': 'Zona',
  'gudang.zone.desc':
    'Area dengan satu kondisi penyimpanan, mis. gudang kering, chiller, atau freezer.',
  'gudang.zone.empty': 'Belum ada zona.',
  'gudang.zone.range': '{min} sampai {max}',
  'gudang.zone.editNamed': 'Ubah zona {code}',
  'gudang.zone.tempMin': 'Suhu minimum (°C)',
  'gudang.zone.tempMax': 'Suhu maksimum (°C)',
  'gudang.zone.tempInvalid': 'Masukkan suhu dengan paling banyak satu desimal, mis. 4 atau -18,5.',
  'gudang.zone.tempOrder': 'Suhu minimum tidak boleh melebihi maksimum.',
  'gudang.bin.add': 'Tambah rak',
  'gudang.bin.needsZone': 'Tambahkan zona terlebih dahulu.',
  'gudang.bin.title': 'Rak',
  'gudang.bin.desc': 'Rak, ambalan, dan bin. STAGING menampung stok yang belum disimpan ke raknya.',
  'gudang.bin.empty': 'Belum ada rak.',
  'gudang.bin.stagingHint': 'Stok belum ditempatkan (sistem)',
  'gudang.bin.notPickable': 'Tidak untuk diambil',
  'gudang.bin.lines': '{count} baris',
  'gudang.bin.stock': 'Stok',
  'gudang.bin.stockOf': 'Stok di {code}',
  'gudang.bin.editNamed': 'Ubah rak {code}',
  'gudang.bin.stagingEdit': 'STAGING dikelola sistem; hanya barcode-nya yang bisa diubah.',
  'gudang.bin.barcodeHint':
    'Opsional. Dicetak di label rak dan dipindai sebagai ganti mengetik kode.',
  'gudang.bin.sequenceHint':
    'Angka lebih kecil diambil lebih dulu dan dikosongkan lebih dulu oleh mutasi tanpa rak.',
  'gudang.bin.pickable': 'Boleh diambil',
  'gudang.bin.pickableHint': 'Matikan untuk rak cadangan yang tidak dipakai saat pengambilan.',
  'gudang.bin.noStock': 'Rak ini kosong.',
  'gudang.bin.expires': 'Kedaluwarsa {date}',
  'gudang.col.code': 'Kode',
  'gudang.col.name': 'Nama',
  'gudang.col.storage': 'Penyimpanan',
  'gudang.col.temperature': 'Suhu',
  'gudang.col.status': 'Status',
  'gudang.col.actions': 'Tindakan',
  'gudang.col.zone': 'Zona',
  'gudang.col.sequence': 'Urutan ambil',
  'gudang.col.barcode': 'Barcode',
  'gudang.col.stock': 'Stok',
  'gudang.col.item': 'Barang',
  'gudang.col.lot': 'Lot',
  'gudang.col.qty': 'Jumlah',
  'gudang.status.active': 'Aktif',
  'gudang.status.inactive': 'Nonaktif',
  'gudang.storage.ambient': 'Suhu ruang',
  'gudang.storage.dry': 'Gudang kering',
  'gudang.storage.chiller': 'Chiller',
  'gudang.storage.freezer': 'Freezer',
  'gudang.storage.staging': 'Staging',
  'gudang.storage.quarantine': 'Karantina',
  'gudang.saved': 'Tersimpan.',
  'gudang.codeHint': 'Huruf besar, angka, dan tanda hubung. Tidak dapat diubah nanti.',
  'gudang.nav.receiving': 'Penerimaan',
  'gudang.nav.checklists': 'Pemeriksaan',
  'gudang.nav.quarantine': 'Karantina',
  'gudang.receiving.title': 'Penerimaan',
  'gudang.receiving.subtitle': 'Kiriman ke {branch}',
  'gudang.receiving.direct': 'Terima tanpa PO',
  'gudang.receiving.expected': 'Kiriman yang ditunggu',
  'gudang.receiving.expectedDesc':
    'Pesanan pembelian yang disetujui dengan jumlah yang belum tiba.',
  'gudang.receiving.noExpected': 'Tidak ada yang ditunggu.',
  'gudang.receiving.po': 'Pesanan pembelian',
  'gudang.receiving.supplier': 'Pemasok',
  'gudang.receiving.expectedDate': 'Diharapkan',
  'gudang.receiving.openLines': 'Belum tiba',
  'gudang.receiving.openLine': '{item}: {qty} {unit}',
  'gudang.receiving.receive': 'Terima',
  'gudang.receiving.receiveNamed': 'Terima {number}',
  'gudang.receiving.receipts': 'Penerimaan barang',
  'gudang.receiving.noReceipts': 'Belum ada penerimaan.',
  'gudang.receiving.number': 'Nomor',
  'gudang.receiving.source': 'Sumber',
  'gudang.receiving.lines': 'Baris',
  'gudang.receiving.value': 'Nilai',
  'gudang.receipt.status.draft': 'Draf',
  'gudang.receipt.status.posted': 'Diposting',
  'gudang.receipt.status.cancelled': 'Dibatalkan',
  'gudang.receipt.title': 'Penerimaan barang',
  'gudang.receipt.subtitle': '{seller} · {source} · ke {location}',
  'gudang.receipt.post': 'Posting penerimaan',
  'gudang.receipt.postTitle': 'Posting {number}?',
  'gudang.receipt.postBody':
    'Barang yang diterima masuk stok sesuai nilainya; barang karantina masuk lokasi karantina; barang ditolak tidak masuk stok. Posting tidak dapat dibatalkan.',
  'gudang.receipt.posted': 'Penerimaan diposting.',
  'gudang.receipt.inspectFirst': 'Periksa baris yang ditandai sebelum posting.',
  'gudang.receipt.lines': 'Baris',
  'gudang.receipt.linesDesc': 'Jumlah diterima, ditolak, dan dikarantina dalam satuan baris.',
  'gudang.receipt.delivered': 'Diterima',
  'gudang.receipt.rejected': 'Ditolak',
  'gudang.receipt.quarantined': 'Dikarantina',
  'gudang.receipt.inspection': 'Pemeriksaan',
  'gudang.receipt.ordered': 'dari {qty} dipesan',
  'gudang.receipt.total': 'Total nilai diterima:',
  'gudang.receipt.back': 'Kembali ke penerimaan',
  'gudang.receipt.quantities': 'Yang tiba',
  'gudang.receipt.quantitiesDesc':
    'Koreksi jumlah, lot, dan tanggal kedaluwarsa sebelum pemeriksaan.',
  'gudang.receipt.quantitiesReset':
    'Menyimpan perubahan jumlah menghapus pemeriksaan yang sudah dilakukan.',
  'gudang.receipt.expiry': 'Tanggal kedaluwarsa',
  'gudang.receipt.saveQuantities': 'Simpan jumlah',
  'gudang.inspection.not_inspected': 'Belum diperiksa',
  'gudang.inspection.passed': 'Lolos',
  'gudang.inspection.partial': 'Sebagian ditahan',
  'gudang.inspection.failed': 'Gagal',
  'gudang.inspection.required': 'Wajib diperiksa',
  'gudang.inspection.inspect': 'Periksa',
  'gudang.inspection.inspectNamed': 'Periksa {item}',
  'gudang.inspection.title': 'Periksa {item}',
  'gudang.inspection.delivered': 'Diterima: {qty} {unit}',
  'gudang.inspection.rejectQty': 'Ditolak di tempat ({unit})',
  'gudang.inspection.rejectReasonLabel': 'Alasan penolakan',
  'gudang.inspection.quarantineQty': 'Ke karantina ({unit})',
  'gudang.inspection.quarantineReasonLabel': 'Alasan karantina',
  'gudang.inspection.temperature': 'Suhu saat tiba (°C)',
  'gudang.inspection.notes': 'Catatan',
  'gudang.inspection.save': 'Simpan pemeriksaan',
  'gudang.inspection.saved': 'Pemeriksaan tersimpan.',
  'gudang.inspection.tooMuch':
    'Jumlah ditolak dan dikarantina tidak boleh melebihi jumlah diterima.',
  'gudang.inspection.rejectReason': 'Beri alasan untuk jumlah yang ditolak.',
  'gudang.inspection.quarantineReason': 'Beri alasan untuk jumlah yang dikarantina.',
  'gudang.direct.title': 'Terima tanpa pesanan pembelian',
  'gudang.direct.subtitle': 'Untuk barang yang dibeli langsung, mis. di pasar.',
  'gudang.direct.supplier': 'Pemasok',
  'gudang.direct.supplierHint': 'Atau kosongkan dan tulis siapa penjualnya.',
  'gudang.direct.noSupplier': 'Tanpa data pemasok',
  'gudang.direct.vendor': 'Dijual oleh',
  'gudang.direct.vendorHint': 'Lapak, toko, atau orang — disimpan untuk penelusuran.',
  'gudang.direct.location': 'Terima ke',
  'gudang.direct.defaultLocation': 'Lokasi utama',
  'gudang.direct.reference': 'Nomor nota',
  'gudang.direct.lines': 'Barang',
  'gudang.direct.chooseItem': 'Pilih barang',
  'gudang.direct.unit': 'Satuan',
  'gudang.direct.qty': 'Jumlah',
  'gudang.direct.price': 'Harga per satuan ({currency})',
  'gudang.direct.removeLine': 'Hapus baris {n}',
  'gudang.direct.addLine': 'Tambah baris',
  'gudang.direct.create': 'Buat penerimaan',
  'gudang.direct.err.seller': 'Pilih pemasok atau tulis siapa penjualnya.',
  'gudang.direct.err.item': 'Pilih barang.',
  'gudang.direct.err.qty': 'Masukkan jumlah di atas nol.',
  'gudang.direct.err.precision': 'Jumlah ini tidak bisa dikonversi tepat ke satuan dasar.',
  'gudang.direct.err.price': 'Masukkan harga per satuan.',
  'gudang.quarantine.title': 'Karantina',
  'gudang.quarantine.subtitle':
    'Stok yang ditahan pemeriksaan mutu dan kasus gudang yang masih terbuka.',
  'gudang.quarantine.stock': 'Di karantina',
  'gudang.quarantine.stockDesc':
    'Milik dan bernilai, tetapi tidak dipakai untuk penjualan, transfer, atau pengambilan sampai dilepas.',
  'gudang.quarantine.empty': 'Tidak ada yang dikarantina.',
  'gudang.quarantine.release': 'Lepas',
  'gudang.quarantine.releaseNamed': 'Lepas {item}',
  'gudang.quarantine.releaseTitle': 'Lepas {item}',
  'gudang.quarantine.qty': 'Jumlah ({unit})',
  'gudang.quarantine.to': 'Pindah ke',
  'gudang.quarantine.reason': 'Alasan',
  'gudang.quarantine.closesException': 'Melepas seluruh jumlah juga menutup kasusnya.',
  'gudang.quarantine.released': 'Dilepas dari karantina.',
  'gudang.quarantine.qtyInvalid': 'Masukkan jumlah sampai sebanyak yang ada di karantina.',
  'gudang.quarantine.reasonRequired': 'Beri alasan minimal 3 karakter.',
  'gudang.exception.title': 'Kasus terbuka',
  'gudang.exception.desc': 'Barang dikarantina atau ditolak dan selisih yang perlu diputuskan.',
  'gudang.exception.empty': 'Tidak ada kasus terbuka.',
  'gudang.exception.type': 'Kasus',
  'gudang.exception.reason': 'Alasan',
  'gudang.exception.source': 'Dokumen',
  'gudang.exception.type.qc_quarantine': 'Dikarantina',
  'gudang.exception.type.supplier_rejection': 'Ditolak saat penerimaan',
  'gudang.exception.type.transfer_variance': 'Selisih transfer',
  'gudang.exception.type.issue_variance': 'Selisih pengeluaran',
  'gudang.exception.type.other': 'Lainnya',
  'gudang.exception.resolve': 'Tutup kasus',
  'gudang.exception.resolveNamed': 'Tutup kasus {item}',
  'gudang.exception.resolveTitle': 'Tutup kasus {item}',
  'gudang.exception.resolution': 'Hasil',
  'gudang.exception.resolution.returned': 'Dikembalikan ke pemasok',
  'gudang.exception.resolution.accepted': 'Diterima apa adanya',
  'gudang.exception.resolution.other': 'Lainnya',
  'gudang.exception.action.return': 'Retur ke pemasok',
  'gudang.exception.action.replacement': 'Pengiriman pengganti',
  'gudang.exception.action.credit_claim': 'Kredit pemasok',
  'gudang.exception.action.accepted_release': 'Terima dan lepas',
  'gudang.exception.supplierReference': 'Referensi pemasok',
  'gudang.exception.replacementReceipt': 'ID penerimaan pengganti',
  'gudang.exception.creditNote': 'ID nota kredit yang diposting',
  'gudang.exception.acknowledge': 'Catat pengakuan',
  'gudang.exception.acknowledged': 'Pengakuan pemasok dicatat.',
  'gudang.exception.acknowledgedBy': 'Pengakuan pemasok: {reference}',
  'gudang.exception.complete': 'Selesaikan resolusi',
  'gudang.exception.note': 'Catatan',
  'gudang.exception.quarantineHint':
    'Menutup kasus tidak memindahkan stok: lepas atau catat sebagai waste secara terpisah.',
  'gudang.exception.resolved': 'Kasus ditutup.',
  'gudang.checklist.title': 'Daftar periksa penerimaan',
  'gudang.checklist.subtitle': 'Yang diperiksa saat barang tiba, per kategori barang.',
  'gudang.checklist.add': 'Tambah daftar periksa',
  'gudang.checklist.list': 'Daftar periksa',
  'gudang.checklist.listDesc':
    'Kategori memakai daftar periksanya sendiri, jika tidak ada memakai daftar untuk semua kategori.',
  'gudang.checklist.empty': 'Belum ada daftar periksa — pemeriksaan tetap opsional.',
  'gudang.checklist.category': 'Kategori barang',
  'gudang.checklist.categoryHint':
    'Kosongkan untuk semua kategori yang tidak punya daftar sendiri.',
  'gudang.checklist.allCategories': 'Semua kategori',
  'gudang.checklist.questions': 'Pertanyaan',
  'gudang.checklist.question': 'Pertanyaan {n}',
  'gudang.checklist.removeQuestion': 'Hapus pertanyaan {n}',
  'gudang.checklist.addQuestion': 'Tambah pertanyaan',
  'gudang.checklist.required': 'Wajib diperiksa',
  'gudang.checklist.requiredHint':
    'Penerimaan dengan barang ini tidak bisa diposting sebelum setiap baris diperiksa.',
  'gudang.checklist.editNamed': 'Ubah {name}',
  'gudang.checklist.incomplete': 'Isi nama dan minimal satu pertanyaan.',
  'gudang.nav.tasks': 'Tugas',
  'gudang.zone.categories': 'Kategori barang yang diizinkan',
  'gudang.zone.categoriesHint':
    'Opsional, pisahkan dengan koma, mis. Susu, Daging. Barang kategori lain tidak bisa disimpan di zona ini.',
  'gudang.zone.onlyCategories': 'Hanya: {list}',
  'gudang.move.action': 'Pindahkan',
  'gudang.move.named': 'Pindahkan {item}',
  'gudang.move.title': 'Pindahkan {item} dari {code}',
  'gudang.move.to': 'Ke rak',
  'gudang.move.qty': 'Jumlah ({unit})',
  'gudang.move.reason': 'Alasan (opsional)',
  'gudang.move.noTarget': 'Tidak ada rak lain yang bisa menerima barang ini.',
  'gudang.move.qtyInvalid': 'Masukkan jumlah di atas nol, paling banyak isi rak.',
  'gudang.move.done': 'Stok dipindahkan.',
  'gudang.tasks.title': 'Tugas penyimpanan',
  'gudang.tasks.subtitle': 'Stok di STAGING yang menunggu disimpan ke rak',
  'gudang.tasks.filter': 'Tampilkan tugas',
  'gudang.tasks.filter.open': 'Terbuka',
  'gudang.tasks.filter.mine': 'Milik saya',
  'gudang.tasks.filter.done': 'Selesai',
  'gudang.tasks.empty': 'Tidak ada yang perlu disimpan.',
  'gudang.tasks.emptyMine': 'Anda belum punya tugas. Ambil dari daftar terbuka.',
  'gudang.tasks.emptyDone': 'Belum ada tugas yang selesai.',
  'gudang.tasks.remaining': '{qty} perlu disimpan',
  'gudang.tasks.staged': 'Hanya {qty} yang masih di STAGING',
  'gudang.tasks.lot': 'Lot {lot}',
  'gudang.tasks.expires': 'kedaluwarsa {date}',
  'gudang.tasks.source.goods_receipt': 'Penerimaan',
  'gudang.tasks.source.stock_transfer': 'Transfer',
  'gudang.tasks.source.quarantine_release': 'Pelepasan karantina',
  'gudang.tasks.source.opening_balance': 'Saldo awal',
  'gudang.tasks.source.stock_count': 'Stok opname',
  'gudang.tasks.source.other': 'Pergerakan stok',
  'gudang.tasks.assignee': 'Ditugaskan ke {name}',
  'gudang.tasks.unassigned': 'Belum ditugaskan',
  'gudang.tasks.overdue': 'Terlambat',
  'gudang.tasks.due': 'Batas {time}',
  'gudang.tasks.claim': 'Ambil',
  'gudang.tasks.claimNamed': 'Ambil tugas {item}',
  'gudang.tasks.claimed': 'Tugas diambil.',
  'gudang.tasks.release': 'Lepas',
  'gudang.tasks.releaseNamed': 'Lepas tugas {item}',
  'gudang.tasks.released': 'Tugas dilepas.',
  'gudang.tasks.putAway': 'Simpan ke rak',
  'gudang.tasks.putAwayNamed': 'Simpan {item} ke rak',
  'gudang.tasks.cancel': 'Batalkan tugas',
  'gudang.tasks.cancelNamed': 'Batalkan tugas {item}',
  'gudang.tasks.cancelTitle': 'Batalkan penyimpanan {item}?',
  'gudang.tasks.cancelBody': 'Stok tetap di tempatnya. Pindahkan nanti dari daftar rak gudang.',
  'gudang.tasks.cancelReason': 'Alasan',
  'gudang.tasks.reasonRequired': 'Isi alasan minimal 3 karakter.',
  'gudang.tasks.cancelled': 'Tugas dibatalkan.',
  'gudang.tasks.statusDone': 'Selesai',
  'gudang.tasks.statusCancelled': 'Dibatalkan',
  'gudang.tasks.finishedAt': 'Ditutup {time}',
  'gudang.putaway.title': 'Simpan {item} ke rak',
  'gudang.putaway.summary': '{qty} perlu disimpan dari STAGING di {location}',
  'gudang.putaway.scan': 'Pindai atau ketik rak',
  'gudang.putaway.scanHint': 'Pindai label rak, atau ketik kodenya lalu tekan Enter.',
  'gudang.putaway.unknownBin': 'Tidak ada rak “{code}” di gudang ini.',
  'gudang.putaway.suggested': 'Saran rak',
  'gudang.putaway.useBin': 'Pakai rak {code}',
  'gudang.putaway.reason.same_lot': 'lot sama',
  'gudang.putaway.reason.same_item': 'barang sama',
  'gudang.putaway.reason.empty': 'kosong',
  'gudang.putaway.reason.other': 'campur',
  'gudang.putaway.placements': 'Penempatan',
  'gudang.putaway.none': 'Pindai rak atau pilih saran.',
  'gudang.putaway.qtyFor': 'Jumlah untuk {code} ({unit})',
  'gudang.putaway.remove': 'Hapus {code}',
  'gudang.putaway.left': 'Sisa setelah ini: {qty}',
  'gudang.putaway.qtyInvalid': 'Setiap jumlah harus di atas nol dan totalnya paling banyak {qty}.',
  'gudang.putaway.confirm': 'Konfirmasi penyimpanan',
  'gudang.putaway.done': 'Stok disimpan.',
  'gudang.nav.requisitions': 'Permintaan',
  'req.col.actions': 'Aksi',
  'req.col.approved': 'Disetujui',
  'req.col.code': 'Kode',
  'req.col.issued': 'Diserahkan',
  'req.col.item': 'Barang',
  'req.col.items': 'Barang',
  'req.col.number': 'Nomor',
  'req.col.picked': 'Diambil',
  'req.col.received': 'Diterima',
  'req.col.requested': 'Diminta',
  'req.col.requestedAt': 'Diminta',
  'req.col.requestedBy': 'Diminta oleh',
  'req.col.status': 'Status',
  'req.status.draft': 'Draf',
  'req.status.submitted': 'Menunggu persetujuan',
  'req.status.approved': 'Disetujui',
  'req.status.picking': 'Sedang diambil',
  'req.status.issued': 'Diserahkan',
  'req.status.completed': 'Diterima',
  'req.status.rejected': 'Ditolak',
  'req.status.cancelled': 'Dibatalkan',
  'req.more': '+{count} lainnya',
  'req.queue.title': 'Permintaan dapur',
  'req.queue.subtitle': 'Setujui, ambil dan serahkan bahan yang diminta dapur',
  'req.queue.filter': 'Tampilkan permintaan',
  'req.queue.todo': 'Perlu dikerjakan',
  'req.queue.issued': 'Menunggu dapur',
  'req.queue.closed': 'Selesai',
  'req.queue.empty': 'Tidak ada permintaan di sini.',
  'req.detail.route': '{from} → {to}',
  'req.detail.approve': 'Setujui',
  'req.detail.approveTitle': 'Setujui {number}',
  'req.detail.approveQty': '{item} ({unit})',
  'req.detail.approveInvalid':
    'Setujui jumlah dari 0 hingga jumlah yang diminta untuk setiap barang.',
  'req.detail.approved': 'Permintaan disetujui.',
  'req.detail.note': 'Catatan (opsional)',
  'req.detail.selfNote': 'Alasan menyetujui permintaan sendiri',
  'req.detail.selfNoteHint':
    'Wajib: Anda sendiri yang meminta. Dicatat sebagai persetujuan sendiri.',
  'req.detail.reject': 'Tolak',
  'req.detail.rejectTitle': 'Tolak {number}?',
  'req.detail.rejected': 'Permintaan ditolak.',
  'req.detail.reason': 'Alasan',
  'req.detail.cancel': 'Batalkan permintaan',
  'req.detail.cancelTitle': 'Batalkan {number}?',
  'req.detail.cancelPicking': 'Stok yang dipesan dilepas dan daftar ambil yang terbuka ditutup.',
  'req.detail.cancelled': 'Permintaan dibatalkan.',
  'req.detail.cancelReason': 'Dibatalkan karena',
  'req.detail.startPicking': 'Mulai ambil',
  'req.detail.pickingStarted': 'Stok dipesan; daftar ambil siap.',
  'req.detail.quickIssue': 'Serahkan sekarang',
  'req.detail.issue': 'Serahkan',
  'req.detail.issued': 'Bahan diserahkan ke dapur.',
  'req.detail.finishPicks': 'Selesaikan semua pengambilan dulu.',
  'req.detail.estimate': 'Perkiraan nilai',
  'req.detail.decision': 'Keputusan',
  'req.detail.automatic': 'Otomatis',
  'req.detail.issuedBy': 'Diserahkan oleh',
  'req.detail.confirmedBy': 'Diterima oleh',
  'req.detail.lines': 'Barang',
  'req.detail.actions': 'Tindakan permintaan',
  'req.detail.linesDesc':
    'Jumlah yang diminta, disetujui, diambil, dan diserahkan tetap terlihat selama proses permintaan ini.',
  'req.detail.searchLines': 'Cari barang atau kode',
  'req.detail.progressFilter': 'Progres',
  'req.detail.allProgress': 'Semua progres',
  'req.detail.progress.pending': 'Menunggu',
  'req.detail.progress.complete': 'Jumlah penuh',
  'req.detail.progress.adjusted': 'Jumlah disesuaikan',
  'req.pick.title': 'Daftar ambil',
  'req.pick.desc':
    'Kedaluwarsa paling awal dulu. Ambil setiap baris dari raknya lalu tandai sudah diambil.',
  'req.pick.bin': 'Rak',
  'req.pick.lot': 'Lot',
  'req.pick.qty': 'Jumlah',
  'req.pick.expires': 'Kedaluwarsa {date}',
  'req.pick.ofPlanned': '{done} dari {planned}',
  'req.pick.picked': 'Sudah diambil',
  'req.pick.pickedNamed': '{item} sudah diambil dari {bin}',
  'req.pick.short': 'Kurang',
  'req.pick.shortNamed': 'Catat pengambilan {item} yang kurang',
  'req.pick.shortTitle': 'Pengambilan {item} kurang',
  'req.pick.shortHint': 'Isi jumlah yang benar-benar ditemukan. Sisa pesanan stok dilepas.',
  'req.pick.foundQty': 'Ditemukan ({unit})',
  'req.pick.shortInvalid': 'Isi jumlah di bawah {qty}.',
  'req.pick.status.open': 'Perlu diambil',
  'req.pick.status.done': 'Diambil',
  'req.pick.status.short': 'Kurang',
  'req.pick.status.cancelled': 'Dibatalkan',
  'req.kitchen.title': 'Permintaan bahan',
  'req.kitchen.subtitle': 'Minta bahan ke gudang dan konfirmasi yang datang',
  'req.kitchen.new': 'Permintaan baru',
  'req.kitchen.empty': 'Belum ada permintaan.',
  'req.kitchen.send': 'Kirim permintaan',
  'req.kitchen.sent': 'Permintaan dikirim ke gudang.',
  'req.kitchen.linesInvalid': 'Pilih barang dan jumlah di atas nol di setiap baris.',
  'req.kitchen.duplicateItem': 'Setiap barang hanya boleh muncul sekali.',
  'req.kitchen.confirm': 'Konfirmasi terima',
  'req.kitchen.confirmNamed': 'Konfirmasi terima {number}',
  'req.kitchen.confirmTitle': 'Apa yang datang untuk {number}?',
  'req.kitchen.confirmHint': 'Isi jumlah yang benar-benar datang. Selisih dilaporkan ke gudang.',
  'req.kitchen.receivedOf': '{item} diterima ({unit}) — {qty} diserahkan',
  'req.kitchen.receivedInvalid': 'Isi jumlah dari 0 hingga jumlah yang diserahkan.',
  'req.kitchen.noteRequired': 'Sebutkan apa yang kurang atau rusak.',
  'req.kitchen.note': 'Catatan',
  'req.kitchen.confirmed': 'Penerimaan dikonfirmasi.',
  'req.field.from': 'Dari',
  'req.field.to': 'Ke',
  'req.field.lines': 'Bahan',
  'req.field.item': 'Barang {n}',
  'req.field.chooseItem': 'Pilih barang',
  'req.field.qty': 'Jumlah ({unit})',
  'req.field.removeLine': 'Hapus baris {n}',
  'req.field.addLine': 'Tambah barang',
  'gudang.direct.emergency': 'Pembelian darurat di luar proses PR/PO normal',
  'gudang.direct.emergencyReason': 'Alasan darurat',
  'gudang.direct.emergencyHint':
    'Jelaskan mengapa proses persetujuan dan pembelian normal tidak dapat diikuti. Orang lain harus meninjaunya.',
  'gudang.direct.err.emergencyReason': 'Isi alasan darurat minimal 3 karakter.',
  'gudang.emergency.title': 'Pembelian darurat',
  'gudang.emergency.not_required': 'Tinjauan tidak diperlukan',
  'gudang.emergency.pending': 'Menunggu tinjauan',
  'gudang.emergency.approved': 'Pembelian darurat disetujui',
  'gudang.emergency.rejected': 'Pembelian darurat ditolak',
  'gudang.emergency.approve': 'Setujui pengecualian',
  'gudang.emergency.reject': 'Tolak pengecualian',
  'gudang.emergency.approveTitle': 'Setujui pembelian darurat ini?',
  'gudang.emergency.rejectTitle': 'Tolak pembelian darurat ini?',
  'gudang.emergency.reviewBody':
    'Catat keputusan setelah memeriksa alasan proses pembelian normal dilewati.',
  'gudang.emergency.reviewNote': 'Catatan tinjauan',
  'gudang.emergency.reviewedBy': 'Ditinjau oleh {name}',
};
